import React, { useEffect, useState } from "react";
import { IonCard, IonIcon } from "@ionic/react";
import { imageOutline, happyOutline, personCircle } from "ionicons/icons";
import useAuth from "../../hooks/useAuth";
import { ReflectionsModalCardProps } from "../../types/socialJournal";
import { getInitials } from "../../utils/helpers";
import Avatar from "../ui/Avatar";
import "../../pages/Journal/MyReflections.css";
const ReflectionsModalCard: React.FC<ReflectionsModalCardProps> = ({
  onOpenModal,
  placeholder = "What's on your mind?",
  setPreSelected,
}) => {
  const { user } = useAuth();
  const [avatarFailed, setAvatarFailed] = useState(false);

  useEffect(() => {
    setAvatarFailed(false); // Reset if user changes
  }, [user]);

  return (
    <IonCard className="rounded-xl shadow-sm bg-white  reflections-modal-card">
      <div className="flex items-center h-20">
        {/* Avatar / Initials */}
        <div className="w-10 h-10 m-3 overflow-hidden rounded-[12px] bg-white-400 flex items-center justify-center cursor-pointer">
          {!avatarFailed && user?.avatar ? (
            <img
              src={user.avatar}
              alt={`${user.first_name || ""} Avatar`}
              className="w-12 h-12 object-cover"
              onError={() => setAvatarFailed(true)}
            />
          ) : user?.first_name || user?.last_name ? (
            <Avatar
              initials={getInitials(
                user?.first_name?.charAt(0) || "",
                user?.last_name?.charAt(0) || ""
              )}
              imageSrc={user?.avatar}
            />
          ) : (
            <IonIcon
              icon={personCircle}
              style={{ fontSize: "30px", color: "rgb(0 124 158 / 1)" }}
              className="text-gray-400 text-2xl"
            />
          )}
        </div>

        {/* Placeholder / Text */}
        <div
          className="flex-1 h-full flex items-center cursor-pointer px-2"
          onClick={onOpenModal}
        >
            <div className="text-gray-700 text-base">
            {placeholder}
            </div>
        </div>

        {/* Action Icons */}
        <div className="flex space-x-3 m-3 px-2">
          <IonIcon
            onClick={() => {
              if (setPreSelected) {
                setPreSelected("images" as any);
              }
              onOpenModal();
            }}
            icon={imageOutline}
            className="text-gray-500 w-5 h-5"
          />
          <IonIcon
            onClick={() => {
              if (setPreSelected) {
                setPreSelected("feelings" as any);
              }
              onOpenModal();
            }}
            icon={happyOutline}
            className="text-gray-500 w-5  h-5"
          />
        </div>
      </div>
    </IonCard>
  );
};

export default ReflectionsModalCard;
